(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elaree-gallery-arrows')) {
    customElements.define(
      'elaree-gallery-arrows',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          this.ready = true;

          this.addEventListener('click', (event) => {
            const button = event.target.closest('button[data-direction]');
            if (!button) return;

            const gallery = this.closest('media-gallery');
            const list = gallery.querySelector('[id^="Slider-Gallery-"]');
            const items = Array.from(list.children).filter(
              item => item.dataset.mediaId && !item.hidden
            );

            if (
              items.length < 2 ||
              typeof gallery.setActiveMedia !== 'function'
            ) return;

            const current = Math.max(
              0,
              items.findIndex(item => item.classList.contains('is-active'))
            );

            const next = (
              current + Number(button.dataset.direction) + items.length
            ) % items.length;

            gallery.setActiveMedia(items[next].dataset.mediaId, false);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
